import { getHouseState, hasFilter } from '../utils';

export const getHousesModel = (state) => {
  return getHouseState(state).housesModel;
};

export const selectSearch = (state) => {
  return getHouseState(state).search;
};

export const selectSelectedSearch = (state) => {
  return getHouseState(state).selectedSearch;
};

export const selectFilter = (state) => {
  return getHouseState(state).filter;
};

export const selectHasFilter = (state) => {
  return hasFilter(selectFilter(state));
};

export const selectHouses = (state) => {
  return getHousesModel(state).values.houses;
};

export const selectHasHouses = (state) => {
  return getHousesModel(state).houses.size > 0;
};

export const selectRelatedRoomIds = (state) => {
  return getHousesModel(state).values.relatedRoomIds;
};

export const selectRelatedRooms = (state) => {
  return getHousesModel(state).values.relatedRoomsForRender;
};

export const selectHasRelations = (state) => {
  return selectRelatedRoomIds(state).size > 0;
};

export const selectExcludedRoomIds = (state) => {
  return getHousesModel(state).values.excludedRoomIds;
};

export const createHasRoomRelationsSelector = (room) => (state) => {
  const house = getHousesModel(state).houses.get(room.houseId);
  return house ? house.roomsWithRelation.has(room.id) : false;
};

export const createHasHouseSelector = (houseId) => (state) => {
  return getHousesModel(state).houses.has(houseId);
};

export const createAllCheckboxStateSelector = (size) => (state) => {
  const currentSize = getHousesModel(state).houses.size;

  if (currentSize === 0) {
    return 'unchecked';
  }

  if (currentSize === size) {
    return 'checked';
  }

  return 'indeterminate';
};

export const createRelatedRoomsCountSelector = (room) => (state) => {
  const house = getHousesModel(state).houses.get(room.houseId);

  if (!house) return 0;

  const roomData = house.roomsWithRelation.get(room.id);

  if (!roomData) return 0;

  return roomData.isParent()
    ? roomData.children.size
    : roomData.parent.children.size;
};

export const createIsRoomExcludedSelector = (houseId, roomId) => (state) => {
  const house = getHousesModel(state).houses.get(houseId);
  return house ? house.excludedRoomIds.has(roomId) : false;
};

export const createExcludedCountSelector = (houseId) => (state) => {
  const house = getHousesModel(state).houses.get(houseId);
  return house ? house.excludedRoomIds.size : 0;
};

export const createHouseExcludedRoomIdsSelector = (houseId) => (state) => {
  const house = getHousesModel(state).houses.get(houseId);
  return house?.excludedRoomIds;
};

export const createRoomsCountSelector = (houseId) => (state) => {
  const house = getHousesModel(state).houses.get(houseId);
  return house ? house.roomsCount : 0;
};
